var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoPause(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipPath: "url(#b)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E3E5FF",
    d: "M24 0a24 24 0 1 1 0 48 24 24 0 0 1 0-48Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18.6 15.4h2.8c.7 0 1.2.5 1.2 1.2v14.8c0 .7-.5 1.2-1.2 1.2h-2.8c-.7 0-1.2-.5-1.2-1.2V16.6c0-.7.5-1.2 1.2-1.2Zm8 0h2.8c.7 0 1.2.5 1.2 1.2v14.8c0 .7-.5 1.2-1.2 1.2h-2.8c-.7 0-1.2-.5-1.2-1.2V16.6c0-.7.5-1.2 1.2-1.2Z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoPause);
export default __webpack_public_path__ + "static/media/video-pause.3b6acec128bbfba1fcff0c52a40b3f5c.svg";
export { ForwardRef as ReactComponent };